import { greeting } from '@/mocks/wedding';

/* The breath of the page — words light up one by one as the section scrolls. */
export default function Manifesto() {
  return (
    <section className="panel manifesto" id="greeting">
      <span className="panel-accent" aria-hidden="true" data-parallax="0.55" data-corner="tr">
        봄
      </span>
      <p className="stamp" data-reveal>
        01 — 인사말
      </p>
      <p className="manifesto-text" data-words>
        서로의 가장 좋은 <em className="accent">계절</em>이 되어, 같은 곳을 바라보며 오래오래 천천히
        걷겠습니다. 부족한 두 사람이 서로를 <em className="accent">닮아가며</em>, 그 시작을 따뜻하게
        지켜봐 주세요.
      </p>
      <p className="manifesto-sign">{greeting.sign}</p>
    </section>
  );
}